import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../../../../services/api";
import DeleteButton from "../../../../components/DeleteButton";
import { FaCheckDouble } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { useAuth } from "../../../../contexts/AuthContext";

function OrderLoadPendingIssues() {
  const { id } = useParams();
  const [pendingIssues, setPendingIssues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const fetchPendingIssues = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.get(`/pending-issues/order-load/${id}`);
        setPendingIssues(response.data);
      } catch (err) {
        setError("Erro ao carregar as pendências.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPendingIssues();
  }, [id]);

  const handleDeletePendingIssue = async (id) => {
    try {
      await api.delete(`/pending-issues/${id}`);
      setPendingIssues((state) =>
        state.filter((pendingIssue) => pendingIssue.id !== id)
      );
    } catch (error) {
      console.log("Erro ao excluir pendencia: ", error);
    }
  };
  const handleResolvedPendingIssue = async (id) => {
    try {
      await api.patch(`/pending-issues/${id}`, { resolved: true });
      setPendingIssues((state) =>
        state.map((pendingIssue) =>
          pendingIssue.id === id
            ? { ...pendingIssue, resolved: true }
            : pendingIssue
        )
      );
    } catch (error) {
      console.log("Erro ao excluir pendencia: ", error);
    }
  };
  const handlePendingIssue = async (id) => {
    try {
      await api.patch(`/pending-issues/${id}`, { resolved: false });
      setPendingIssues((state) =>
        state.map((pendingIssue) =>
          pendingIssue.id === id
            ? { ...pendingIssue, resolved: false }
            : pendingIssue
        )
      );
    } catch (error) {
      console.log("Erro ao excluir pendencia: ", error);
    }
  };

  if (loading) return <div>Carregando pendências...</div>;
  if (error) return <div className="text-red-500">{error}</div>;

  return (
    <div className="w-full flex justify-center mx-auto p-4 mt-16">
      <div>
        <div className="flex items-center justify-between mb-4 w-[1000px]">
          <h1 className="text-2xl font-bold mb-4">Pendências</h1>
          {user && user.accessType === "AGENT" && (
            <button
              className="px-6 py-4 bg-orange-500 text-white rounded-md font-semibold"
              onClick={() => navigate(`/cargas/${id}/criar-pendencia`)}
            >
              Criar Pendência
            </button>
          )}
        </div>
        {pendingIssues.length > 0 ? (
          <div className="overflow-y-auto max-h-[450px] custom-scrollbar pr-4">
            <ul className="space-y-4">
              {pendingIssues.map((issue) => (
                <li
                  key={issue.id}
                  className="p-4 w-[1000px] border flex justify-between rounded-md shadow-sm bg-gray-100"
                >
                  <div className="w-[90%]">
                    <h2 className="font-semibold text-lg mb-4">
                      {issue.title}
                    </h2>
                    <p className="text-gray-700 mb-4">{issue.description}</p>
                    <p className="text-sm text-gray-500 mb-2">
                      Criado em: {new Date(issue.createdAt).toLocaleString()}
                    </p>
                    <p
                      className={`text-sm  font-semibold ${
                        issue.resolved ? "text-green-600" : "text-red-600"
                      }`}
                    >
                      {issue.resolved ? "Resolvido" : "Pendente"}
                    </p>
                  </div>
                  <div className="flex flex-col items-center justify-center gap-8">
                    <DeleteButton
                      onConfirm={() => handleDeletePendingIssue(issue.id)}
                    />
                    {issue.resolved ? (
                      <button
                        className="text-red-500 text-xl"
                        onClick={() => handlePendingIssue(issue.id)}
                      >
                        <RxCross2 />
                      </button>
                    ) : (
                      <button
                        className="text-green-500"
                        onClick={() => handleResolvedPendingIssue(issue.id)}
                      >
                        <FaCheckDouble />
                      </button>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div className="text-gray-500">Nenhuma pendência encontrada.</div>
        )}
      </div>
    </div>
  );
}

export default OrderLoadPendingIssues;
